import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import {FormLabel, Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";

const centerContainer = {
    display: 'flex',
    justifyContent:'center',
    alignItems:'center'
};

export default function LinearDeterminate() {
    const [progress, setProgress] = React.useState(0);

    React.useEffect(() => {
        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    return 0;
                }
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 100);
            });
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, []);

    return (
        <Box sx={{ width: '100%' }}>
            <h2 style={centerContainer}>{Math.round(progress)}%</h2>
            <Tooltip title={Math.round(progress)}>
                <LinearProgress variant="determinate" value={progress} />
            </Tooltip>
        </Box>
    );
}